import WithMainLayout from "../../hocs/layouts/MainLayout";
import PublicCalculators from "../Public/PublicCalculators";

export default WithMainLayout(PublicCalculators, "Calculadoras");
